import React, { Component } from "react";
import { Container, CardDeck } from 'react-bootstrap';
import Cards from '../../component/Cards/Cards';
import Footers from "../../component/Footers/Footer";
import { clearCache } from "../../adalConfig";
import avatar from '../../avatar.svg';
import man from '../../man.svg'
import ErrorModal from "../../component/ErrorModal/ErrorModal";
import ConfirmModal from "../../component/ErrorModal/ConfirmModal";
import Headers from '../../component/Headers/Headers';
import { authContext } from "../../adalConfig";

const newStudent = {
    Title: "For New RP Student",
    Text: "",
    Url: '/Login'
};

const currentStudent = {
    Title: "For RP Student and Staff",
    Text: "Login with MYRP account and password",
    Url: '/AzureLogin'
}

class Landing extends Component {
    state = {
        show: false
    }

    componentDidMount() {
        // To check whether it is routed from failed Azure Login
        if (this.props.location) {
            if (this.props.location.state) {
                console.log(this.props.location.state.error)
                //Clear Azure token from failed login via Azure AD
                clearCache();

                //Show error emssage from failed Azure Login
                this.setState({
                    show: true,
                    errorMsg: this.props.location.state.error,
                    showlogout: this.props.location.state.showlogout
                })

                //Set location.state to null to prevent recurring error message when referesh
                this.props.history.replace({
                    pathname: '/',
                    state: null
                })


            }
        }
    }

    closeHandler = () => {
        this.setState({ show: false })
    }

    LogoutHandler = () => {
        this.setState({ show: false })
        localStorage.clear()
        authContext.logOut()   
    }

    render() {
        return (
            <div>
                <Headers />
                <Container>
                    <div className='guidelines text-center mt-5'>
                        <p>This website is best viewed in Chrome and Safari</p>
                    </div>
                    <CardDeck className="mb-2 mt-5">
                        <Cards title={currentStudent.Title} text={currentStudent.Text} url={currentStudent.Url} icon={avatar} />
                        <Cards title={newStudent.Title} text={newStudent.Text} url={newStudent.Url} icon={man} />
                    </CardDeck>
                </Container>

                <div className='guidelines enquire text-center mt-5'>
                        If you have any questions, please contact us via <a target="_blank" href="https://for.edu.sg/rpcontactus">Online Enquiry Form</a>
                    </div>
                <Footers />
                <ErrorModal msg={this.state.errorMsg} show={this.state.show} showlogout={this.state.showlogout}  click={() => this.closeHandler()} logout={() => this.LogoutHandler()} />

            </div>

        );
    }

}

export default Landing;